import React from "react";
import classNames from "classnames";
import { FinancialDocument } from "@common/types/financialDocument";
import styles from "./ImportedDocuments.module.scss";
import { ImportedDocumentsRow } from "./ImportedDocumentsRow";

interface Props {
    financialDocuments: FinancialDocument[];
    onRemoveItem: (item: FinancialDocument) => void;
    className?: string;
}

export const ImportedDocuments: React.FC<Props> = ({
    financialDocuments,
    onRemoveItem,
    className,
}) => (
    <section className={classNames(styles.documentsTable, className)}>
        <header className={classNames(styles.header, styles.row)}>
            <span>Name</span>
            <span>Status</span>
        </header>

        {financialDocuments.map((document) => (
            <ImportedDocumentsRow
                financialDocument={document}
                onRemove={() => onRemoveItem(document)}
                key={document.id}
            />
        ))}
    </section>
);
